{
  "browserNotSupported": {
    "title": "Nie udało się wczytać modułu",
    "text": "Aby skorzystać z przeglądarki części, proszę przejść do aktualnej przeglądarki."
  },
  "main": {
    "more": "Więcej akcesoriów",
    "findMore": "Akcesoria do modernizacji/przebudowy i modernizacji pojazdu można znaleźć tutaj w naszej szerokiej ofercie. Wybrane akcesoria zostaną wysłane do partnera {{brand}} wraz z zapytaniem dotyczącym pojazdu.",
    "topOffers": "NAJLEPSZE oferty",
    "article": "<0>{{min}} - {{max}} / </0>{{productCount}} Produktów",
    "noArticleFound": "0 Produktów",
    "oemHint": "Wybierz teraz pasujące akcesoria dla swojego {{brand}}!",
    "noBrand": "Wybierz teraz pasujące akcesoria do swojego pojazdu!",
    "outOfOrder": "Niestety w tej chwili nie ma dostępnych produktów.<0/>Obecnie aktualizujemy nasz katalog.<0/>Zapraszamy do odwiedzenia nas ponownie w późniejszym terminie.",
    "nextSlide": "Następny",
    "prevSlide": "Poprzedni"
  },
  "cart": {
    "add": "Produkt dodany do pojazdu",
    "fullPrice": "Cena pojazdu i akcesoriów",
    "priceWithoutCar": "Akcesoria cenowe"
  },
  "navigation": {
    "zoom": "Powiększ",
    "toggleSearch": "Przełącz wyszukiwanie",
    "cart": "Koszyk",
    "cartDelete": "Usuń produkt z koszyka",
    "vehicle": "Wybrany pojazd",
    "maxBookmarksReached": "Maksymalnie 15 osiągniętych produktów",
    "filter": {
      "toggleFilter": "Przełącz filtr",
      "topProducts": "NAJLEPSZE oferty",
      "reset": "Zresetuj filtr",
      "ready": "Gotowe",
      "show": "Pokaż wyniki"
    },
    "searching": {
      "submit": "Szukaj",
      "close": "Zamknij",
      "placeholder": "Znajdź pasujące akcesoria ...",
      "suggestions": "Podpowiedzi wyszukiwania",
      "categories": "Kategorie",
      "products": "Produkty",
      "productCount": "{{count}} produkt",
      "productCount_one": "{{count}} produkt",
      "productCount_few": "{{count}} produkty",
      "productCount_many": "{{count}} produktów",
      "showAll": "Pokaż {{count}} wynik",
      "showAll_one": "Pokaż {{count}} wynik",
      "showAll_few": "Pokaż wszystkie {{count}} wyniki",
      "showAll_many": "Pokaż wszystkie {{count}} wyników",
      "expand": "Rozszerzone wyszukiwanie",
      "show": "Pokaż wyniki",
      "found": {
        "withCategory": "Wyniki wyszukiwania dla \"{{fuzzy}}\" w kategorii \"{{category}}\"",
        "withOutCategory": "Wyniki wyszukiwania dla \"{{fuzzy}}\" ze wszystkich kategorii"
      }
    },
    "share": "Akcji",
    "back": "Powrót",
    "details": "Szczegóły",
    "add": "Dodaj",
    "remove": "Usuń",
    "close": "Zamknij",
    "filtern": "Filtr",
    "closeFilter": "Zamknij filtr"
  },
  "productDetail": {
    "gallery": {
      "jumpToImageNumber": "Przejdź do zdjęcia {{number}}"
    },
    "articleNumber": "Numer artykułu",
    "relatedArticle": "Mogą Państwa zainteresować również te artykuły:",
    "brand": "Marka",
    "priceBox": {
      "withVatAndMounting": "z VAT & montażem",
      "withVat": "z VAT",
      "recommendedRetailPrice": "Sugerowana cena detaliczna",
      "historicMinimalPurchasePrice": "Najniższa cena z ostatnich 30 dni",
      "priceDetails": "Szczegóły dotyczące ceny",
      "priceDetailsHeadline": "Szczegóły dotyczące ceny tego produktu",
      "priceToday": "Cena za ten produkt dzisiaj",
      "priceDetails30Days": "Najniższa cena w ciągu 30 dni przed zmianą ceny",
      "close": "Zamknij",
      "addItem": "Dodaj artykuł",
      "removeItem": "Usuń artykuł"
    },
    "infoBox": {
      "description": "Opis",
      "vehicles": "Odpowiedni dla następujących modeli",
      "empty": "Dla tego produktu nie ma specjalnych przeznaczeń dla pojazdów.",
      "contacts": "Producent"
    },
    "contacts": {
      "manufacturer-contact": "Informacje kontaktowe producenta",
      "responsible-contact": "Osoba odpowiedzialna w UE",
      "trademark": "Marka"
    }
  },
  "productList": {
    "oemHint": "Oryginalne akcesoria do twojej marki {{brand}}"
  }
}
